// extracted by mini-css-extract-plugin
export default {"block":"UserNav_block__uQ4E9","link":"UserNav_link__fxyF+","activeLink":"UserNav_activeLink__pj4Y8 UserNav_link__fxyF+","nav":"UserNav_nav__sm+rv","item":"UserNav_item__V9wdj"};